
"use strict";

import numberFormat from "../common/number-format";

var keySearch = {
    'by_broadcaster': 1,
    'by_channel': 3,
    null: 3
};

export default function renderWeeklyReportCSV(data, options) {
    if(! data.length) {
        return 'No data for this week yet'
    }

    const decimals = (parseInt(options.dataType) === 0) ? 0 : 2;
    let pattern = "";
    const rows = data.filter(
        s => options.showTotal ? true : (s.station_name.match(new RegExp("^(?!Reporting Universe$).*", "i")))
    ).filter(
        s => options.filter ? (s.station_name.match(new RegExp(options.filter.value + "|Reporting Universe" + "|Total TV", "i"))) : true
    ).filter(
        s => keySearch[options.view_type] ? (s.channel_type.match(new RegExp("^" + keySearch[options.view_type] + "|0", "i")) || options.activeFilter === false) : true
    ).
    map((row) => {
        const nullValueSymbol = (row.station_id === "Reporting Universe" || row.station_id === "Total TV") ? "" : "-";

        if (options['definition_type'] === 'ttsv') {
            pattern = `"${(row.channel_weekly_reach_val) ? row.channel_weekly_reach_val : nullValueSymbol}",` +
                `"${(row.channel_weekly_reach_perc) ? numberFormat(row.channel_weekly_reach_perc, decimals) : nullValueSymbol}",` +
                `"${(row.channel_weekly_share_val) ? numberFormat(row.channel_weekly_share_val, decimals) : nullValueSymbol}",` +
                `="${(row.channel_avg_daily_minutes_val) ? row.channel_avg_daily_minutes_val : nullValueSymbol}"`; // "=" character fix render problem on Excel
        } else {
            pattern = `"${(row.bcaster_weekly_reach_val) ? row.bcaster_weekly_reach_val : nullValueSymbol}",` +
                `"${(row.bcaster_weekly_reach_perc) ? numberFormat(row.bcaster_weekly_reach_perc, decimals) : nullValueSymbol}",` +
                `"${(row.bcaster_weekly_share_val) ? numberFormat(row.bcaster_weekly_share_val, decimals) : nullValueSymbol}",` +
                `="${(row.bcaster_avg_daily_minutes_val) ? row.bcaster_avg_daily_minutes_val : nullValueSymbol}"`;
        }

        return `"${row.station_name}",` + pattern
    }).join("\n");

    if (options['definition_type'] === 'ttsv') {
        return `"",` +
            `"Total Four Screen Viewing (As Viewed)",` +
            `"", , ,` +
            "\r\n" +
            `"", , ,` +
            `"Universe: UK TV & Broadband Households",` +
            "\r\n" +
            `"Channel",` +
            `"Four Week Reach",` +
            `"",` +
            `"Four Week Share",` +
            `"Average Daily Minutes",` +
            "\r\n" +
            `"   ",` +
            `"000s",` +
            `"%",` +
            `"%",` +
            `"MM:SS",` +
            `\r\n${rows}`;
    }

    return `"",` +
        `"C7 TV SET (As Broadcast)",` +
        `"", , , ` +
        "\r\n" +
        `"",` +
        `"Universe: UK TV Households",` +
        "\r\n" +
        `"Channel",` +
        `"Weekly Reach",` +
        `"",` +
        `"Weekly Share",` +
        `"Average Daily Minutes",` +
        "\r\n" +
        `"   ",` +
        `"000s",` +
        `"%",` +
        `"%",` +
        `"MM:SS",` +
        `\r\n${rows}`;
};
